import { Util } from '@libs/utilities/util';

import { EnumTextFormat } from '../kw-workbench.interface';


export class TextFormatPipeHelper {


	processTextFormatting(keywords: string[], textFormat: EnumTextFormat): string[] {

		//0 - is the formatting option valid?
		if (!Util.Enum.isValid(EnumTextFormat, textFormat)) throw new Error(`TextFormatPipeHelper => processTextFormatting => FATAL ERROR: the textFormat of "${textFormat}" is invalid (valid are: "${Util.Enum.values(EnumTextFormat).join(', ')}")`);

		//1 - format the text of the keywords
		switch (textFormat) {
			case EnumTextFormat.KeepOriginal:
				return keywords;

			case EnumTextFormat.TitleCase:
				return keywords.map((elem: string) => Util.String.titleCase(elem));

			case EnumTextFormat.UpperCase:
				return keywords.map((elem: string) => elem.toUpperCase());

			case EnumTextFormat.LowerCase:
				return keywords.map((elem: string) => elem.toLowerCase());

			default:
				throw new Error(`TextFormatPipeHelper => processTextFormatting => FATAL ERROR: formatting behavior of "${textFormat}" is not defined`);
		}
	}
}
